import React from 'react'

export interface User {
  id: string
  email: string
  name: string | null
  isAdmin: boolean | null
  isOperator: boolean | null
  isAuthorizedViaSSO: boolean | null
  isAutoprovisionedForSSO: boolean | null
  ssoAuthorizedWorkspace: Workspace | null
  verification: string | null
  pendingEmail: string | null
}

export interface Workspace {
  id: string
  slug: string
  name: string
}

export interface UserContext {
  refreshUser: () => void
  user: User | null
}

const defaultState = {
  refreshUser: () => {
    return
  },
  user: null
}

const context = React.createContext<UserContext>(defaultState)
const Provider = context.Provider
const Consumer = context.Consumer

export default context
export { Provider, Consumer }
